<template>
  <div>
    <v-btn
      v-if="currentUser?.hasPermission('incident_reports.download_incidentreport')"
      class="mr-3 text-capitalize"
      color="primary"
      flat
      :loading="isDownloading"
      :disabled="loading"
      @click="emit('download-report-pressed')"
      >Download PDF</v-btn
    >

    <MoreOptionsMenuButton>
      <template #button="props">
        <v-btn
          v-bind="props"
          :loading="loading"
          :disabled="loading || isDownloading"
          class="text-capitalize"
          append-icon="mdi-menu-down"
          variant="outlined"
        >
          More Options
        </v-btn>
      </template>

      <v-list-item title="View Audit Logs" @click="emit('view-report-logs-pressed')"> </v-list-item>
      <v-list-item
        v-if="
          currentUser?.hasPermission('incident_reports.add_incidentreportsummary') && !summaryExists
        "
        title="Create Summary Report"
        @click="emit('create-summary-report-pressed')"
      >
      </v-list-item>

      <v-list-item
        v-if="
          currentUser?.hasPermission('incident_reports.change_incidentreportsummary') &&
          summaryExists
        "
        title="Edit Summary Report"
        @click="emit('edit-summary-report-pressed')"
      >
      </v-list-item>
      <v-list-item
        v-if="currentUser?.hasPermission('incident_reports.approve_incidentreport')"
        title="Share Report"
        @click="emit('share-report-pressed')"
      >
      </v-list-item>
    </MoreOptionsMenuButton>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAuthStore } from '@/stores'
import MoreOptionsMenuButton from '@/components/common/MoreOptionsMenuButton.vue'

interface Props {
  loading?: boolean
  summaryExists?: boolean
  isDownloading?: boolean
}
defineProps<Props>()

interface Emit {
  (e: 'download-report-pressed'): void
  (e: 'view-report-logs-pressed'): void
  (e: 'create-summary-report-pressed'): void
  (e: 'edit-summary-report-pressed'): void
  (e: 'share-report-pressed'): void
}
const emit = defineEmits<Emit>()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
